import { lazy } from "react";

const Users = lazy(()=>import("../pages/Users"));
const Login = lazy(()=>import("../pages/Login"));
const Groups = lazy(()=>import("../pages/Groups"));
const Albums = lazy(()=>import("../pages/Albums"));
const Support = lazy(()=>import("../pages/Support"));
const Profile = lazy(()=>import("../pages/Profile"));
const Favorites = lazy(()=>import("../pages/Favorites"));
const UserReport = lazy(()=>import("../pages/UserReport"));
const GroupReport = lazy(()=>import("../pages/GroupReport"));
const EditProfile = lazy(()=>import("../pages/EditProfile"));
const GroupMember = lazy(()=>import("../pages/GroupMember"));
const NewDashboard = lazy(()=>import("../pages/NewDashboard"));
const InstagramConnect = lazy(()=>import("../pages/Instagram"));
const Notifications = lazy(()=>import("../pages/Notifications"));
const Subscriptions = lazy(()=>import("../pages/Subscriptions"));
const Verifications = lazy(()=>import("../pages/Verifications"));
const ChangePassword = lazy(()=>import("../pages/ChangePassword"));
const ForgotPassword = lazy(()=>import("../pages/ForgotPassword"));
const UserDescription = lazy(()=>import("../pages/UserDescription"));
const AlbumDetails = lazy(()=>import("../pages/Albums/AlbumDetails"));
const UserReportMember = lazy(()=>import("../pages/UserReportMember"));
const GroupReportMember = lazy(()=>import("../pages/GroupReportMember"));
const NotificationDetail = lazy(()=>import("../pages/NotificationDetail"));
const VerificationRequest = lazy(()=>import("../pages/VerificationRequest"));

export const pageRoutes = {
  // dashboard: "/",
  newDashBoard: "/",
  login: "/login",
  profile: "/profile",
  editProfile: "/edit-profile",
  changePassword: "/change-password",
  forgotPassword: "/forgot-password",
  users: "/users",
  userDescription: "/user-description",
  groups: "/groups",
  groupMember: "/group-member",
  userReport: "/user-report",
  GroupReport: "/group-report",
  userReportMember: "/user-report-member",
  notifications: "/notifications",
  subscriptions: "/subscriptions",
  verifications: "/verifications",
  verificationRequest: "/verification-request",
  InstagramConnect: "/ig-callback",
  GroupReportMember: "/Group-Report-Member",
  notificationDetail: "/notification-detail",
Support: "/support",
Albums: "/albums",
AlbumDetails: "/album-details",
Favorites: "/favorites",
};

export const AllRoutes = [
  // {
  //     name: "Dashboard",
  //     path: pageRoutes.dashboard,
  //     element: <Dashboard />,
  //     isPrivate: true,
  // },
  {
    name: "NotificationDetail",
    path: pageRoutes.notificationDetail,
    element: <NotificationDetail />,
    isPrivate: true,
  },
  {
    name: "newDashBoard",
    path: pageRoutes.newDashBoard,
    element: <NewDashboard />,
    isPrivate: true,
  },
  {
    name: "Login",
    path: pageRoutes.login,
    element: <Login />,
    isPrivate: false,
  },
  {
    name: "Profile",
    path: pageRoutes.profile,
    element: <Profile />,
    isPrivate: true,
  },
  {
    name: "EditProfile",
    path: pageRoutes.editProfile,
    element: <EditProfile />,
    isPrivate: true,
  },
  {
    name: "ChangePassword",
    path: pageRoutes.changePassword,
    element: <ChangePassword />,
    isPrivate: true,
  },
  {
    name: "ForgotPassword",
    path: pageRoutes.forgotPassword,
    element: <ForgotPassword />,
    isPrivate: false,
  },
  {
    name: "Users",
    path: pageRoutes.users,
    element: <Users />,
    isPrivate: true,
  },
  {
    name: "userDescription",
    path: pageRoutes.userDescription,
    element: <UserDescription />,
    isPrivate: true,
  },
  {
    name: "Groups",
    path: pageRoutes.groups,
    element: <Groups />,
    isPrivate: true,
  },
  {
    name: "groupMember",
    path: pageRoutes.groupMember,
    element: <GroupMember />,
    isPrivate: true,
  },
  {
    name: "UserReport",
    path: pageRoutes.userReport,
    element: <UserReport />,
    isPrivate: true,
  },
  {
    name: "GroupReport",
    path: pageRoutes.GroupReport,
    element: <GroupReport />,
    isPrivate: true,
  },
  {
    name: "GroupReportMember",
    path: pageRoutes.GroupReportMember,
    element: <GroupReportMember />,
    isPrivate: true,
  },
  {
    name: "UserReportMember",
    path: pageRoutes.userReportMember,
    element: <UserReportMember />,
    isPrivate: true,
  },
  {
    name: "Notifications",
    path: pageRoutes.notifications,
    element: <Notifications />,
    isPrivate: true,
  },
  {
    name: "Subscriptions",
    path: pageRoutes.subscriptions,
    element: <Subscriptions />,
    isPrivate: true,
  },
  {
    name: "Verifications",
    path: pageRoutes.verifications,
    element: <Verifications />,
    isPrivate: true,
  },
  {
    name: "VerificationRequest",
    path: pageRoutes.verificationRequest,
    element: <VerificationRequest />,
    isPrivate: true,
  },
  {
    name: "InstagramConnect",
    path: pageRoutes.InstagramConnect,
    element: <InstagramConnect />,
    isPrivate: false,
  },
  {
    name: "Support",
    path: pageRoutes.Support,
    element: <Support />,
    isPrivate: false,
  },
  {
    name: "Albums",
    path: pageRoutes.Albums,
    element: <Albums />,
    isPrivate: false,
  },
  {
    name: "AlbumDetails",
    path: pageRoutes.AlbumDetails,
    element: <AlbumDetails />,
    isPrivate: false,
  },
  {
    name: "Favorites",
    path: pageRoutes.Favorites,
    element: <Favorites />,
    isPrivate: false,
  },
];
